import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { Instagram } from 'lucide-react';
import { useText } from '../../lib/siteContent';

// Simple TikTok icon (lucide doesn't include it)
const TiktokIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-.88-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.91a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.34Z"/>
  </svg>
);

const Footer = () => {
  const t = useText();
  const [settings, setSettings] = useState({
    footer_email: "hello@jbmhevents.com",
    footer_phone: "",
    instagram_url: "",
    tiktok_url: "",
    footer_tagline: "L'art du détail, la signature de l'élégance",
  });

  useEffect(() => {
    api.get('/site-settings')
      .then(({ data }) => setSettings((prev) => ({ ...prev, ...data })))
      .catch(() => {});
  }, []);

  const hasSocial = settings.socials?.length > 0;

  return (
    <footer id="contact" className="bg-[#FFFFFF] border-t border-[#111111]/10 text-[#111111] pt-32 pb-12 relative overflow-hidden">

      <div className="container-custom relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-start mb-24 gap-16">

          {/* Brand */}
          <div className="md:w-1/3">
            <h2 className="text-4xl md:text-5xl font-serif mb-8 tracking-wide">{t('footer.brand')}</h2>
            <p className="text-[#111111]/60 text-lg font-serif italic max-w-sm mb-12">
              « {settings.footer_tagline} »
            </p>
            <a href="/devis" className="inline-block px-8 py-4 border border-[#111111] text-[#111111] text-xs uppercase tracking-[0.2em] hover:bg-[#111111] hover:text-white transition-all">
              {t('footer.cta')}
            </a>
          </div>

          {/* Links Grid */}
          <div className="md:w-2/3 grid grid-cols-1 md:grid-cols-3 gap-12">
            <div>
              <h4 className="text-xs uppercase tracking-[0.2em] text-[#111111] mb-8">Contact</h4>
              <div className="flex flex-col gap-6 text-sm font-light text-[#111111]/80">
                {settings.footer_email && (
                  <a href={`mailto:${settings.footer_email}`} className="hover:text-[#6B6B6B] transition-colors">
                    {settings.footer_email}
                  </a>
                )}
                {settings.footer_phone && (
                  <a href={`tel:${settings.footer_phone.replace(/\s/g, '')}`} className="hover:text-[#6B6B6B] transition-colors">
                    {settings.footer_phone}
                  </a>
                )}
              </div>
            </div>

            <div>
              <h4 className="text-xs uppercase tracking-[0.2em] text-[#111111] mb-8">Suivez-nous</h4>
              <div className="flex flex-col gap-6 text-sm font-light text-[#111111]/80">
                {(settings.socials || []).map((l, i) => (
                  <a key={i} href={l.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 hover:text-[#6B6B6B] transition-colors" data-testid={`footer-social-${i}`}>
                    {l.network === 'tiktok' ? <TiktokIcon className="w-4 h-4" /> : <Instagram className="w-4 h-4" />} {l.label}
                  </a>
                ))}
                {!hasSocial && (
                  <span className="text-[#6B6B6B] italic text-xs">Bientôt en ligne</span>
                )}
              </div>
            </div>

            <div>
              <h4 className="text-xs uppercase tracking-[0.2em] text-[#111111] mb-8">Légal</h4>
              <div className="flex flex-col gap-6 text-sm font-light text-[#111111]/80">
                <a href="/services" className="hover:text-[#6B6B6B] transition-colors" data-testid="footer-link-services">Nos services</a>
                <a href="/faq" className="hover:text-[#6B6B6B] transition-colors">FAQ</a>
                <a href="/conditions" className="hover:text-[#6B6B6B] transition-colors">Conditions</a>
                <a href="/mentions-legales" className="hover:text-[#6B6B6B] transition-colors">Mentions légales</a>
                <a href="/confidentialite" className="hover:text-[#6B6B6B] transition-colors">Politique de confidentialité</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#111111]/10 pt-12 flex flex-col md:flex-row justify-between items-center text-xs text-[#111111]/40 uppercase tracking-widest">
          <p>&copy; {new Date().getFullYear()} JBMH EVENTS. Tous droits réservés.</p>
          <p className="mt-4 md:mt-0">{t('footer.zone')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
